"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyQueryParamsForWorkspace = void 0;
const react_1 = require("react");
const graphql_1 = require("../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const query_params_1 = require("./query-params");
const product_tree_nodes_1 = require("../client/product-tree-nodes");
const hooks_1 = require("../strategy-matrix/client/hooks");
const store_1 = require("../../store");
const useApplyQueryParamsForWorkspace = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const params = (0, query_params_1.useQueryParams)();
    const terminalNodeIdParamRef = (0, react_1.useRef)(params.terminalNodeId);
    const attributeNameParamRef = (0, react_1.useRef)(params.attributeName);
    const valueParamRef = (0, react_1.useRef)(params.value);
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const expandedNodes = (0, store_1.useExpandedNodes)();
    const { data: ancestors, isLoading, error, } = (0, hooks_1.useGetNodeRelations)({
        productTreeNodeId: terminalNodeIdParamRef.current,
        sort: [{ distance: graphql_1.SortOrder.Asc }],
    });
    (0, react_1.useEffect)(() => {
        if (selectedCatalogId) {
            if (terminalNodeIdParamRef.current && ancestors.length) {
                const pathIds = ancestors.map((edge) => edge.node.ancestor.id);
                const nodePath = pathIds.join(store_1.STRATEGY_NODE_PATH_SEPARATOR);
                if (nodePath) {
                    const newExpandedNodes = (0, product_tree_nodes_1.getExpandedNodesListByPath)(nodePath);
                    const expanded = new Set([...newExpandedNodes, ...(expandedNodes !== null && expandedNodes !== void 0 ? expandedNodes : [])]);
                    terminalNodeIdParamRef.current = undefined;
                    dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(nodePath));
                    dispatch((0, store_1.enrichAISetExpandedNodes)(Array.from(expanded)));
                    const { current: attributeName } = attributeNameParamRef;
                    const { current: value } = valueParamRef;
                    if (attributeName && value) {
                        attributeNameParamRef.current = undefined;
                        valueParamRef.current = undefined;
                        dispatch((0, store_1.enrichAISetSelectedAttributeNode)({
                            label: attributeName,
                            value,
                        }));
                    }
                }
            }
        }
    }, [selectedCatalogId, ancestors, expandedNodes, dispatch]);
    return {
        isLoading,
        error,
    };
};
exports.useApplyQueryParamsForWorkspace = useApplyQueryParamsForWorkspace;
